import { StateCreator } from 'zustand'
import { DEFAULT_SETTINGS } from '../../constants/invoice'
import { sampleInvoice } from '../../constants/invoice'
import { ensureInvoiceId } from '../../utils/invoiceCalculations'
import type { SyncedInvoice } from '../../types/invoice'
import { LoadingState } from '../../types/invoice'
import type { InvoiceStore } from '../invoiceStore'

export interface StoreManagementSlice {
    resetStore: () => void
    cleanup: () => void
}

export const createStoreManagementSlice: StateCreator<
    InvoiceStore,
    [],
    [],
    StoreManagementSlice
> = (set, get) => ({
    resetStore: () => {
        // First set the basic state
        set({
            invoices: [],
            savedInvoices: [],
            currentInvoice: ensureInvoiceId(sampleInvoice) as SyncedInvoice, // Use sample invoice initially
            editingSection: null,
            loadingState: LoadingState.IDLE,
            error: null,
            lastSyncTime: null,
            settings: DEFAULT_SETTINGS
        });

        // Then reset the current invoice using the function that will use settings
        get().resetCurrentInvoice();

        // Clear local storage
        localStorage.removeItem('dutchinvoice_local_invoices');
        localStorage.removeItem('dutchinvoice_local_settings');
    },

    cleanup: () => {
        // Clean up any subscriptions or side effects
    }
}) 